import { render, staticRenderFns } from "./SourcesStats.vue?vue&type=template&id=1661db46"
import script from "./SourcesStats.vue?vue&type=script&lang=js"
export * from "./SourcesStats.vue?vue&type=script&lang=js"
import style0 from "./SourcesStats.vue?vue&type=style&index=0&id=1661db46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports